import React from 'react';
import { motion } from 'framer-motion';
import { 
  Users, 
  Shield, 
  CreditCard, 
  Store, 
  MessageSquare, 
  Bell, 
  Settings
} from 'lucide-react';
import { Link } from 'react-router-dom';

function QuickActions() {
  const actions = [
    {
      title: 'Users',
      description: 'Manage user accounts',
      icon: <Users className="h-5 w-5 text-blue-500" />,
      color: 'bg-blue-50',
      textColor: 'text-blue-600',
      path: '/users'
    },
    {
      title: 'Roles',
      description: 'Manage permissions',
      icon: <Shield className="h-5 w-5 text-indigo-500" />,
      color: 'bg-indigo-50',
      textColor: 'text-indigo-600',
      path: '/roles'
    },
    {
      title: 'Subscriptions',
      description: 'Manage plans & pricing',
      icon: <CreditCard className="h-5 w-5 text-purple-500" />,
      color: 'bg-purple-50',
      textColor: 'text-purple-600',
      path: '/subscriptions'
    },
    {
      title: 'Pet Store',
      description: 'Manage items & inventory',
      icon: <Store className="h-5 w-5 text-pink-500" />,
      color: 'bg-pink-50',
      textColor: 'text-pink-600',
      path: '/pets'
    },
    {
      title: 'Trigger',
      description: 'Manage trigger interactions',
      icon: <MessageSquare className="h-5 w-5 text-green-500" />,
      color: 'bg-green-50',
      textColor: 'text-green-600',
      path: '/trigger'
    },
    {
      title: 'Notifications',
      description: 'Manage app notifications',
      icon: <Bell className="h-5 w-5 text-yellow-500" />,
      color: 'bg-yellow-50',
      textColor: 'text-yellow-600',
      path: '/notifications'
    }
  ];
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };
  
  return (
    <motion.div 
      className="bg-white rounded-lg shadow-sm p-6 mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-medium">Quick Actions</h2>
        {/* <motion.div 
          className="py-1 px-3 bg-gray-100 rounded-md text-xs font-medium"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Settings className="h-3.5 w-3.5 inline mr-1" />
          Customize
        </motion.div> */}
      </div>
      
      <motion.div 
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {actions.map((action, index) => (
          <motion.div 
            key={index} 
            variants={item}
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            whileTap={{ scale: 0.95 }}
          >
            <Link to={action.path} className="block">
              <div className={`p-4 rounded-lg ${action.color} h-full flex flex-col items-center text-center`}>
                <div className="mb-3">
                  {action.icon}
                </div>
                <h3 className={`text-sm font-medium ${action.textColor}`}>
                  {action.title}
                </h3>
                <p className="text-xs text-gray-500 mt-1">
                  {action.description}
                </p>
              </div>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}

export default QuickActions;